// Configurable map provider. OSM is the local/dev default (see OSM Tile Usage
// Policy: https://operations.osmfoundation.org/policies/tiles/). OSM explicitly
// warns commercial services that access can be withdrawn and blocks cloud IP
// ranges, so production must set VITE_MAP_TILES_URL to a commercial-friendly
// OSM-derived provider (e.g. Stadia Maps, MapTiler, or OpenFreeMap).
export const MAP_TILES_URL: string =
  (import.meta.env?.VITE_MAP_TILES_URL as string | undefined) ??
  'https://tile.openstreetmap.org/{z}/{x}/{y}.png'

export const MAP_ATTRIBUTION: string =
  (import.meta.env?.VITE_MAP_ATTRIBUTION as string | undefined) ??
  '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap</a> contributors'

export const MAP_TILE_SIZE = 256
